import React from 'react';
import './spinner.css';

export default function Spinner({isUpload=false}) {
	return <div className='lds-dual-ring' style={{marginLeft: isUpload?0:'45%'}}></div>;
}
